import axios from "axios";
import ChatMessage from "./chatMessage";
import { useLayoutEffect, useState } from "react";

export default function ProblemBubble({ apiRoot, problemName }) {
    const [problemText, setProblemText] = useState("Loading...");
    useLayoutEffect(() => {
        const fetchProblemText = async () => {
            const response = await axios.get(`${apiRoot}/getProblem?problemId=${problemName}`);
            setProblemText(response.data);
        };
        fetchProblemText();
    }, [apiRoot, problemName]);

    return (
        <ChatMessage variant="system" isUser={false}>
            {problemText}
        </ChatMessage>
    );
}